export const getIsShrinkSidebar = (state) =>
  state.sidebar.sidebarPosition === 'closed' ? true : false;
